module.exports = __webpack_public_path__ + "3721eb57ea3f64e7d77c886aa341700d.svg";